import * as types from '../../actions/actionTypes';
import initialState from '../initialState';

export default function competencyTreeEditorReducer(state = initialState.treeEditorCompetencies, action) {
    switch (action.type) {
        case types.LOAD_COMPETENCIES_SUCCESS:
//            console.log(sortCategories(action.categories.map(categories => formatFetchedCategory(categories))));
            return action.competencies.map(competencies => formatFetchedCompetency(competencies));
        case types.ADD_COMPETENCY_SUCCESS:
            return action.competencies.map(competencies => formatFetchedCompetency(competencies));
        case types.UPDATE_COMPETENCY_SUCCESS:
//            console.log(sortCategories(action.categories.map(categories => formatFetchedCategory(categories))));
            return action.competencies.map(competencies => formatFetchedCompetency(competencies));
        case types.DELETE_COMPETENCY_SUCCESS:
            return action.competencies.map(competencies => formatFetchedCompetency(competencies));
        default:
            return state;
    }
}

//function sortCategories(categories) {
//    return _.sortBy(categories, ['order']);
//}

function formatFetchedCompetency(competency) {
    return {
        id: competency.id,
        parentId: competency.parent_id,
        expanded: true,
        title: competency.title,
        used: competency.used,
        order: competency.order,
        // children: category.children
    };
}


// WEBPACK FOOTER //
// ./web/src/reducers/categoryTreeEditor/competencyTreeEditorReducer.js